/* eslint-disable max-len */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'interfaces';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state['feature/session/summary'] || initialState;

export const selectLoader = createSelector([selectDomain], (SessionSummaryState) => SessionSummaryState.loading);
export const selectActionLoader = createSelector([selectDomain], (SessionSummaryState) => SessionSummaryState.actionLoading);
export const selectCertificatesLoader = createSelector(
  [selectDomain],
  (SessionSummaryState) => SessionSummaryState.certificatesStateLoading,
);
export const selectCertificatesRefetchTrigger = createSelector(
  [selectDomain],
  (SessionSummaryState) => SessionSummaryState.certificatesRefetchTrigger,
);
export const selectCertificatesExportSuccessTrigger = createSelector(
  [selectDomain],
  (SessionSummaryState) => SessionSummaryState.certificatesExportSuccessTrigger,
);
export const selectSession = createSelector([selectDomain], (SessionSummaryState) => SessionSummaryState.session);
export const selectSessionCertificates = createSelector(
  [selectDomain],
  (SessionSummaryState) => SessionSummaryState.sessionCertificates,
);
export const selectIssuingCertificateUserId = createSelector(
  [selectDomain],
  (SessionSummaryState) => SessionSummaryState.issuingCertificateUserId,
);
export const selectBulkIssuingCertificatesLoading = createSelector(
  [selectDomain],
  (SessionSummaryState) => SessionSummaryState.bulkIssuingCertificatesLoading,
);
export const selectExportingCertificatesLoading = createSelector(
  [selectDomain],
  (SessionSummaryState) => SessionSummaryState.exportingCertificatesLoading,
);
export const selectSessionUrl = createSelector([selectDomain], (SessionSummaryState) => SessionSummaryState.sessionUrl);
